import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { ApplicationFacade, OpenTripPlannerService } from '@ridango/components';
import {
    getDefaultValue,
    JourneyPlannerFilter
} from '@ridango/components/lib/open-trip-planner/journey-planner-filter.model';

@Component({
    selector: 'rwidget-planner-filter-modal',
    templateUrl: './journey-planner-filter-modal.component.html',
    styleUrls: ['./journey-planner-filter-modal.component.scss']
})
export class JourneyPlannerFilterModalComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;
    filterReady = !this.env.JOURNEY_PLANNER?.FILTERS?.TRANSPORT_MODE;
    readonly maxWalkDistanceSelector = this.env.JOURNEY_PLANNER?.FILTERS?.SELECTORS.find(
        (selector) => selector.TITLE_KEY === 'JOURNEY_PLANNER_FILTER_MAX_WALK_DISTANCE_TITLE'
    );
    @Input() filter: JourneyPlannerFilter;
    private defaultFilterValue: JourneyPlannerFilter;

    constructor(
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private optService: OpenTripPlannerService
    ) {}

    closeModal() {
        this.modalCtrl.dismiss({ filter: null, defaultFilter: null }, 'cancel');
    }

    handleNextClick() {
        this.modalCtrl.dismiss({ filter: this.filter, defaultFilter: this.defaultFilterValue }, 'cancel');
    }

    handleResetClicked() {
        this.optService
            .getDefaultRouteFilters(getDefaultValue(this.env.JOURNEY_PLANNER?.FILTERS))
            .subscribe((filters) => {
                this.filter = filters;
            });
    }

    filterChangedHandler(filter) {
        this.filter = filter;

        const maxWalkDistanceValue = this.maxWalkDistanceSelector?.VALUES[filter.maxWalkDistance]?.VALUE;

        if (maxWalkDistanceValue) {
            this.filter.maxWalkDistance = maxWalkDistanceValue;
        }
    }

    filterReadyHandler() {
        this.defaultFilterValue = this.defaultFilterValue || this.filter;
        this.filterReady = true;
    }
}
